module.exports = __webpack_public_path__ + "static/media/product33.45971dd2.jpg";